import { logBase } from '../../../../../shared/misc-utilities/misc-utils';
// @ts-ignore
import { Options, SLIC } from '../js-segment-annotator-code/slic';
import { AbstractAlgorithmAdapter } from './abstract-algorithm-adapter';

/**
 * The smallest we want a superpixel to be (roughly). This is 10x10.
 */
const smallestRegionSize = 10;
const defaultNumberOfSuperpixels = 2000;
const minNumberOfSuperpixels = 50;

const sizeAdjustFactor = Math.sqrt(2);

export class SLICAdapter extends AbstractAlgorithmAdapter<Options> {
  readonly name = 'SLIC';

  get minRelativeSize() {
    return Math.ceil(
      -logBase(sizeAdjustFactor, this.defaultRegionSize / smallestRegionSize),
    );
  }

  get maxRelativeSize() {
    return Math.floor(
      logBase(
        sizeAdjustFactor,
        this.regionSizeToFit(minNumberOfSuperpixels) / this.defaultRegionSize,
      ),
    );
  }

  private get defaultRegionSize() {
    return this.regionSizeToFit(defaultNumberOfSuperpixels);
  }

  protected executeAlgorithm(options: Options) {
    // @ts-ignore
    return new SLIC(this.image, options).result;
  }

  protected defaultOptions() {
    return this.options(this.defaultRegionSize);
  }

  protected adjustForSmallerSuperpixels({ regionSize }: Options) {
    return this.options(regionSize / sizeAdjustFactor);
  }

  protected adjustForBiggerSuperpixels({ regionSize }: Options) {
    return this.options(regionSize * sizeAdjustFactor);
  }

  private options(regionSize: number) {
    return {
      regionSize: Math.round(regionSize),
      minRegionSize: Math.round(regionSize * 0.8),
    };
  }

  private regionSizeToFit(numberOfSuperpixels: number) {
    return Math.sqrt(this.imageArea / numberOfSuperpixels);
  }
}
